<template>
  <van-collapse v-model="activeNames">
      <van-collapse-item  name="1" class="sale-sec">
        <template #title>
          <div class="sec-title">
            <img src="../assets/mt/mtwm.png" alt="" width="32px" height="32px">
            <p class="van-ellipsis">外卖红包(20-4等各款红包)</p>
            <van-button round color="linear-gradient(to right, #ee0a24, #ff6034)" @click.stop="toMt">领红包</van-button>
          </div>
        </template>

        <template #default>
          <div class="sec-detail">
            <p class="van-ellipsis" style="font-size:12px">美团外卖推出重磅红包，还有返佣。</p>
            <div class="sec-btn">
              <van-grid :gutter="10" :column-num="3">
                <div class="van-grid-item" style="flex-basis: 33.3333%; padding-right: 10px;display:block">
                  <div class="van-grid-item__content van-grid-item__content--center van-grid-item__content--surround van-hairline" style="padding:0">
                    <van-button round  color="linear-gradient(to right, #ee0a24, #ff6034)" @click.stop="toMtQr('33', 'poster')" style="padding:0">小程序领券</van-button>
                  </div>
                </div>
                <div class="van-grid-item" style="flex-basis: 33.3333%; padding-right: 10px;">
                  <div class="van-grid-item__content van-grid-item__content--center van-grid-item__content--surround van-hairline">
                    <van-button round color="#ffbd00" @click="toggleMtHaibao">分享赚钱</van-button>
                  </div>
                </div>
                <div class="van-grid-item" style="flex-basis: 33.3333%; padding-right: 10px;">
                  <div class="van-grid-item__content van-grid-item__content--center van-grid-item__content--surround van-hairline">
                    <van-button round color="#ffbd00" @click="copyWenan">复制文案</van-button>
                  </div>
                </div>
              </van-grid>
            </div>
          </div>
        </template>
      </van-collapse-item>

    <van-collapse-item  name="2" class="sale-sec">
      <template #title>
        <div class="sec-title">
          <img src="../assets/mt/mtwm.png" alt="" width="32px" height="32px">
          <p class="van-ellipsis">外卖品质商家活动</p>
          <van-button round color="linear-gradient(to right, #ee0a24, #ff6034)" @click.stop="toMtQr('31', 'poster')">领红包</van-button>
        </div>
      </template>

      <template #default>
        <div class="sec-detail">
          <p class="van-ellipsis" style="font-size:12px">品质商家，优品优价<br>优质商家25-8、35-10。</p>
          <div class="sec-btn">
            <van-grid :gutter="10" :column-num="3">
              <div class="van-grid-item" style="flex-basis: 33.3333%; padding-right: 10px;display:block">
                <div class="van-grid-item__content van-grid-item__content--center van-grid-item__content--surround van-hairline" style="padding:0;display:none">
                  <van-button round  color="linear-gradient(to right, #ee0a24, #ff6034)" @click.stop="toMtQr('31', 'poster')" style="padding:0">小程序领券</van-button>
                </div>
              </div>
              <div class="van-grid-item" style="flex-basis: 33.3333%; padding-right: 10px;">
                <div class="van-grid-item__content van-grid-item__content--center van-grid-item__content--surround van-hairline">
                  <van-button round color="#ffbd00" @click="toggleMtHaibao">分享赚钱</van-button>
                </div>
              </div>
              <div class="van-grid-item" style="flex-basis: 33.3333%; padding-right: 10px;">
                <div class="van-grid-item__content van-grid-item__content--center van-grid-item__content--surround van-hairline">
                  <van-button round color="#ffbd00" @click="copyWenan">复制文案</van-button>
                </div>
              </div>
            </van-grid>
          </div>
        </div>
      </template>
    </van-collapse-item>


      <van-collapse-item title="标题3" name="3" class="sale-sec store mb-80" >
        <template #title>
          <div class="sec-title">
            <img src="../assets/mt/mtsx02.png" alt="" width="32px" height="32px">
            <p class="van-ellipsis">商超生鲜药房菜大全红包</p>
            <van-button round color="linear-gradient(to right, #ee0a24, #ff6034)" @click.stop="toMtsx">领红包</van-button>
          </div>
        </template>
        <template #default>
          <div class="sec-detail">
            <p class="van-ellipsis" style="font-size:12px">商超生鲜红包天天领，最高34元红包，还有返佣</p>
            <div class="sec-btn">
              <van-grid :gutter="10" :column-num="3">
                <div class="van-grid-item" style="flex-basis: 33.3333%; padding-right: 10px;display:block">
                  <div class="van-grid-item__content van-grid-item__content--center van-grid-item__content--surround van-hairline" style="color:red;padding:0">
                    <van-button round color="linear-gradient(to right, #ee0a24, #ff6034)" @click.stop="toMtQr('4', 'poster')" style="padding:0">小程序领券</van-button>
                  </div>
                </div>
                <div class="van-grid-item" style="flex-basis: 33.3333%; padding-right: 10px;">
                  <div class="van-grid-item__content van-grid-item__content--center van-grid-item__content--surround van-hairline">
                    <van-button round color="#01b233" @click="toggleSxHaibao">分享赚钱</van-button>
                  </div>
                </div>
                <div class="van-grid-item" style="flex-basis: 33.3333%; padding-right: 10px;">
                  <div class="van-grid-item__content van-grid-item__content--center van-grid-item__content--surround van-hairline">
                    <van-button round color="#01b233"  class="push-btn" @click="copySxWenan()">复制文案</van-button>
                  </div>
                </div>
              </van-grid>
            </div>
          </div>
        </template>
      </van-collapse-item>

  </van-collapse>
</template>

<script>
    import {
        Button
    } from "vant";
    export default {
        components: {
            [Button.name]: Button
        },
        data() {
            return {
                activeNames: ['1','2','3']
            }
        },
        methods: {
            toMt(){
                this.$emit("toMt")
            },
            toMtQr(code, type){
                this.$emit("toMtWmQr", code, type)
            },

            toggleMtHaibao(){
                this.$emit("toggleMtHaibao")
            },

            copyWenan(){
                this.$emit("copyWenan")
            },

            toMtsx(){
                this.$emit("toMtsx")
            },


            toggleSxHaibao(){
                this.$emit("toggleSxHaibao")
            },

            copySxWenan(){
                this.$emit("copySxWenan")
            },

        }
    };
</script>
<style>
  @import '../assets/css/common.css';
</style>
<style type="text/css" scoped>
  .sale-sec .van-grid-item__content--surround::after {
    border-width: 0;
  }
  .sale-sec .van-grid-item__content {
    padding: 0;
  }
  .sale-sec .van-grid-item__content::after {
    border-width: 0;
  }
  .sale-sec button{
    width: 100%;
    height: 30px;
  }
  .sec-title >>> .van-button {
    width: 70px;
    padding: 0;
  }

  .sale-sec >>> .van-cell {
    background: none !important;
    padding: 0;
  }
  .sale-sec >>> .van-collapse-item__content {
    padding: 0;
  }
  .sale-sec >>> .van-icon {
    width: 26px;
    height: 26px;
    border-radius: 15px;
    background: rgba(255, 255, 255, 0.7);
    margin-top: 11px;
    text-align: center;
    line-height: 26px;
  }
  .store {
    background-image: -webkit-linear-gradient(to right,#01b233,#eefa40);
    background-image: -moz-linear-gradient(to right,#01b233,#eefa40);
    background-image: linear-gradient(to right,#01b233,#eefa40);
  }
</style>

